import { gql } from 'urql';

export const CURRENT_USER = gql`
	query CurrentUser {
		currentUser {
			id
			name
			email
		}
	}
`;

export const QUERY_USER_LOGIN = gql`
	mutation Login($input: LoginInput!) {
		login(input: $input) {
			access_token
			refresh_token
		}
	}
`;

export const QUERY_REFRESH_TOKEN = gql`
	mutation RefreshToken($input: RefreshTokenInput!) {
		refreshToken(input: $input) {
			access_token
			refresh_token
		}
	}
`;

// export const MUTATION_VERIFY_EMAIL = gql`
// 	mutation VerifyEmail($input: VerifyEmailInput!) {
// 		verifyEmail(input: $input) {
// 			access_token
// 			refresh_token
// 		}
// 	}
// `;

// export const MUTATION_FORGOT_PASSWORD = gql`
// 	mutation ForgotPassword($input: ForgotPasswordInput!) {
// 		forgotPassword(input: $input) {
// 			status
// 			message
// 		}
// 	}
// `;

// export const MUTATION_REGISTER = gql`
// 	mutation Register($input: RegisterInput) {
// 		register(input: $input) {
// 			access_token
// 		}
// 	}
// `;
